/** Shared chart-to-planet frame for authored geometry and authoritative solids.
 * Local Y follows the planet normal; local X follows the chart-space yaw. */
import * as pmath from '../pmath.js';
import {localToDir, type CityGraph} from './citygraph.js';

export function chartPlacementFrame(
  g: CityGraph,
  radius: number,
  placement: {center: readonly number[]; yaw: number},
) {
  const direction: number[] = [0, 0, 0], next: number[] = [0, 0, 0];
  const [u, height, v] = placement.center;
  localToDir(g.frame, u, v, direction);
  localToDir(g.frame, u + pmath.cos(placement.yaw), v + pmath.sin(placement.yaw), next);
  const width = next.map((value, i) => value - direction[i]);
  const dot = width[0] * direction[0] + width[1] * direction[1] + width[2] * direction[2];
  for (let i = 0; i < 3; i++) width[i] -= dot * direction[i];
  const length = pmath.hypot(width[0], width[1], width[2]);
  for (let i = 0; i < 3; i++) width[i] /= length;
  return {center: direction.map(value => value * (radius + height)), up: direction, width};
}
